import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AccountMasterRoutingModule } from './account-master-routing.module';
import { AccountComponent } from './account.component';
import { MasterComponent } from './master.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { IconSpriteModule } from 'ng-svg-icon-sprite';
import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';
import { UpdateProfileComponent } from './update-profile/update-profile.component';
import {ChangePasswordComponent} from './change-password/change-password.component';
import { UserIdleModule } from 'angular-user-idle';
import { NotificationsComponent } from './notifications/notifications.component';
import { MomentModule } from 'ngx-moment';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NgZorroAntdModule, NzButtonModule, NzDatePickerModule, NzDropDownModule, NzInputModule, NzPaginationModule, NzTableModule, NzTagModule, NzToolTipModule } from 'src/app/utilities/ng-zorro-antd.module';
@NgModule({
    declarations: [AccountComponent, MasterComponent, AboutUsComponent, UpdateProfileComponent, ChangePasswordComponent, NotificationsComponent
    ],
    imports: [
        CommonModule,
        FormsModule, ReactiveFormsModule,
        AccountMasterRoutingModule,
        NzLayoutModule,
        NzGridModule,
        NzMenuModule,
        NzIconModule,
        NgZorroAntdModule,
        IconSpriteModule,
        NgxQRCodeModule,
        NzDropDownModule,
        NzTableModule,
        NzTagModule,
        NzButtonModule,
        NzGridModule,
        NzToolTipModule,
        NzPaginationModule,
        NzDatePickerModule,
        NzInputModule,
        NzIconModule,
        IconSpriteModule.forRoot({ path: 'filepath' }),
        MomentModule
    ]
})
export class AccountMasterModule { }
